import { FC, useEffect } from "react";
import { message } from "antd";
import { MailOutlined, PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";
import {
    Contacts,
    ContactsIcon,
    ContactsItem,
    DescriptionContainer,
    DescriptionText,
    DescriptionTitle,
    Discount,
    DiscountContainer,
    HeadAdditionalInfo,
    PageHeadTitle,
    Parameter,
    PromoCode
} from "./styled";
import { Consent } from "./Consent";
import { Rules } from "./Rules";
import { getStaticUrl, setDocumentTitle } from "../../../utils";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { SiteType, TeamContext } from "../../../types/common";

export const StadiumPage: FC = () => {
    const configuration = useConfiguration();

    useEffect(() => {
        setDocumentTitle(`Стадион - Официальный сайт ${configuration.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
    }, [configuration.site]);

    const parameters = {
        category: '3А',
        name: "Стадион ФК «Родина»",
        address: "г. Москва, ул. 3-я Гражданская, 47",
        capacity: "2825",
        parkingCapacity: "35",
        promoCode: "#ТОПИЗАРОДИНУ",
        discountSize: "10%",
        phone: "+7 495 963 81 97",
        email: "stadion@fcrodina.com",
    }

    const copyPromoCode = () => {
        navigator?.clipboard?.writeText(parameters.promoCode).then(() => {
            message.success('Промокод скопирован в буфер обмена');
        });
    }

    return (
        <div>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif' }} className="w-full aspect-video relative">
                <img
                    src={getStaticUrl('/static/images/stadium/header.jpg')}
                    alt={parameters.name}
                    className="w-full h-full object-cover"
                />
                <div className="box-border absolute top-0 left-0 right-0 bottom-0 text-center pt-2 sm:py-4 h-full w-full flex flex-col justify-between text-white">
                    <PageHeadTitle className="text-3xl sm:text-7xl">{parameters.name}</PageHeadTitle>
                    <HeadAdditionalInfo className="text-2xl sm:text-5xl flex flex-col items-start gap-1 text-left px-1 sm:px-4  md:text-center md:flex-row md:justify-between md:items-center">
                        <div>
                            Классификация {parameters.category}
                        </div>
                        <div>
                            Адрес: {parameters.address}
                        </div>
                    </HeadAdditionalInfo>
                </div>
            </div>
            <div className="p-2 sm:p-4 max-w-[1024px] mx-auto">
                <DescriptionContainer>
                    <div className="flex flex-row flex-wrap gap-2">
                        <Parameter>
                            <img src={getStaticUrl('/static/images/stadium/capacity.svg')} className="h-16" />
                            <div>{parameters.capacity} мест</div>
                        </Parameter>
                        <Parameter>
                            <img src={getStaticUrl('/static/images/stadium/parking.svg')} className="h-16" />
                            <div>{parameters.parkingCapacity} машиномест</div>
                        </Parameter>
                        <Parameter>
                            <img src={getStaticUrl('/static/images/stadium/field.svg')} className="h-16" />
                            <div>Искуственный газон с подогревом</div>
                        </Parameter>
                        <Parameter>
                            <img src={getStaticUrl('/static/images/stadium/fitting-rooms.svg')} className="h-16" />
                            <div>Раздевалки с душевыми</div>
                        </Parameter>
                    </div>
                    {configuration.teamName !== TeamContext.ACADEMY && <>
                        <DescriptionTitle>
                            АРЕНДА
                        </DescriptionTitle>
                        <Contacts>
                            <ContactsItem href="tel:+74959638197">
                                <ContactsIcon><PhoneOutlined /></ContactsIcon>
                                {parameters.phone}
                            </ContactsItem>
                            <ContactsItem href={`mailto:${parameters.email}`}>
                                <ContactsIcon>
                                    <MailOutlined />
                                </ContactsIcon>
                                {parameters.email}
                            </ContactsItem>
                            <ContactsItem href="https://wa.me/79959227492">
                                <ContactsIcon $color="#28D146">
                                    <WhatsAppOutlined />
                                </ContactsIcon>
                                ЧАТ С МЕНЕДЖЕРОМ
                            </ContactsItem>
                        </Contacts>

                        <DiscountContainer>
                            <Discount>
                                Скидка {parameters.discountSize}
                            </Discount>
                            <DescriptionText>по промокоду <PromoCode onClick={copyPromoCode}>{parameters.promoCode}</PromoCode></DescriptionText>
                        </DiscountContainer>
                    </>}
                </DescriptionContainer>
                <hr />
                <Rules />
                <Consent />
            </div>
        </div >
    )
}